import { ChangeDetectionStrategy, Component, effect, input, OnInit, output, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs';

@Component({
  selector: 'lib-ikp-search-bar',
  imports: [ReactiveFormsModule],
  templateUrl: './search-bar.component.html',
  styleUrl: './search-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchBarComponent implements OnInit {
  isUserInput = signal(false);
  searchTerm = input<string>('');
  readonly dataTestPageAttribute = input.required<string>();
  readonly triggerSearch = output<string>();
  searchInput = new FormControl('');

  constructor() {
    effect(() => {
      this.searchInput.setValue(this.searchTerm());
    });
  }

  ngOnInit(): void {
    this.searchInput.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe((input: string) => {
      this.search();
      this.isUserInput.set(input.length > 0);
    });
  }

  search() {
    this.triggerSearch.emit(this.searchInput.value);
  }

  reset() {
    this.searchInput.setValue('');
    this.triggerSearch.emit(this.searchInput.value);
  }
}
